import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  // i18n.language can carry a region subtag ('en-CA', 'fr-CA') when it comes
  // from the browser language detector rather than an explicit click. Compare
  // on the base tag only, otherwise NEITHER button renders as active on a
  // fresh visit from a Canadian browser. Mirrors KioskLanguageToggle.
  const active = (i18n.language || 'en').split('-')[0];

  return (
    <div className="flex items-center space-x-2">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={active === code}
          className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
            active === code
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
